import { MFS_CARD_TYPE, MFS_TAG_TYPE } from '../../utility/constant/constants';
/** Typeguard to determine if an MfsItem is a Card */
export const IsMfsTagTypeguard = (item) => item.label === MFS_TAG_TYPE;
/** Gets a typeguard for the extended MfsItem type. */
export function getMfsTagTypeguard() {
    return (item) => item.label === MFS_TAG_TYPE;
}
/** Gets a typeguard for the extended MfsItem type. */
export function getMfsCardTypeguard() {
    return (item) => item.label === MFS_CARD_TYPE;
}
//# sourceMappingURL=folderInternalTypeGuard.js.map